import { memo, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface Props {
	className?: string;
	variant: 'filled' | 'outlined';
	children: ReactNode;
}

const Circle = ({ children, className }: Props) => {
	return <div className={className}>{children}</div>;
};

const Memoized = memo(Circle);
const Styled = styled(Memoized)`
	${({ variant }) =>
		variant === 'filled'
			? css`
					--size: 1.75rem;
					width: var(--size);
					min-width: var(--size);
					height: var(--size);
					min-height: var(--size);
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
					background-color: ${({ theme }) => theme.v2.color.neutral[1100]};
				`
			: css`
					--size: 1rem;
					width: var(--size);
					min-width: var(--size);
					height: var(--size);
					min-height: var(--size);
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
					border: 1px solid ${({ theme }) => theme.v2.color.neutral[1100]};
				`}
`;

export { Styled as Circle };
